// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NavBar.css */
.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #333;
    padding: 10px 20px;
  }
  
  .navbar-logo img {
    height: 40px;
  }
  
  .navbar-links {
    display: flex;
    gap: 20px;
  }
  
  .nav-link {
    color: white;
    text-decoration: none;
    font-size: 18px;
  }
  
  .nav-link:hover {
    text-decoration: underline;
  }

  .nav-link-button:hover {
    text-decoration: underline;
  }
  
  .nav-link-button {
    color: #fff;
    background-color: #333;
    font-size: 17px;
    padding: 0;
    margin: 0;
    border: none;
    cursor: pointer;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB","sourcesContent":["/* NavBar.css */\n.navbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #333;\n    padding: 10px 20px;\n  }\n  \n  .navbar-logo img {\n    height: 40px;\n  }\n  \n  .navbar-links {\n    display: flex;\n    gap: 20px;\n  }\n  \n  .nav-link {\n    color: white;\n    text-decoration: none;\n    font-size: 18px;\n  }\n  \n  .nav-link:hover {\n    text-decoration: underline;\n  }\n\n  .nav-link-button:hover {\n    text-decoration: underline;\n  }\n  \n  .nav-link-button {\n    color: #fff;\n    background-color: #333;\n    font-size: 17px;\n    padding: 0;\n    margin: 0;\n    border: none;\n    cursor: pointer;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
